<template>
        <div class="mb-3" :class="sizeClassObject">
        <temp-ranking-confirmation-list ref="confirmationsListGrid"
                                        @sizeToggle="sizeToggle"
                                        :confirmationExpanded="expanded">
        </temp-ranking-confirmation-list>
    </div>
</template>

<script>
    import TempRankingConfirmationList from '../../components/dynamic/ranking/TempRankingConfirmationList';
    import { DynamicLayoutPageSize } from '../../models/enums';

    export default {
        props: {
            size: Number
        },
        data() {
            return {
                expanded: this.size === 12,
            }
        },
        components: {
            TempRankingConfirmationList
        },
        methods: {
            sizeToggle() {
                this.expanded = !this.expanded;
            },
        },
        computed: {
            sizeClassObject() {
                return this.$helpers.sizeClassObject(this.expanded ? DynamicLayoutPageSize.Max : Math.min(this.size, 6));
            }
        }
    }
</script>
